import PropTypes from 'prop-types'

export const SHAPE_FACTSHEET_BLUEPRINT = {
  components: PropTypes.array.isRequired,
  factTree: PropTypes.shape(
    {
      sections: PropTypes.object.isRequired,
      facts: PropTypes.object.isRequired,
      attributes: PropTypes.object.isRequired,
      units: PropTypes.object.isRequired
    }
  )
}
export const SHAPE_COMPONENT = {
  type: PropTypes.string.isRequired,
  id: PropTypes.string,
  components: PropTypes.array
}

export const SHAPE_DATA_FACT = {
  factDefId: PropTypes.string.isRequired,
  attributes: PropTypes.objectOf(
    PropTypes.shape({
      attributeDefId: PropTypes.string.isRequired
    }),
  ),
  appliesTo: PropTypes.arrayOf(PropTypes.string)
}

export const SHAPE_VARIANT = {
  variantId: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired
}

export const SHAPE_VARIANT_GROUP = {
  variantGroupTypeId: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  variants: PropTypes.arrayOf(PropTypes.shape(SHAPE_VARIANT))
}
